import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  position() {
    return faker.datatype.number(10);
  },

  afterCreate(productContributor, server) {
    productContributor.update({
      artist: server.create('artist'),
      category: server.create('category', 'contributorFunction'),
    });
  },
});
